import * as React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  error?: boolean;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(({ className, error, children, ...props }, ref) => (
  <div className="relative inline-flex">
    <select
      ref={ref}
      className={cn(
        "appearance-none rounded-sm border border-line bg-surface py-1.5 pl-2.5 pr-8 text-[13px] font-medium text-text outline-none transition-colors hover:border-muted focus:border-primary focus:shadow-[0_0_0_3px_var(--ads-primary-soft)]",
        error && "border-danger",
        className
      )}
      {...props}
    >
      {children}
    </select>
    <ChevronDown aria-hidden className="pointer-events-none absolute right-2.5 top-1/2 size-3.5 -translate-y-1/2 text-muted" />
  </div>
));
Select.displayName = "Select";

export { Select };